"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var gridHeaderRowCell_1 = require("./gridHeaderRowCell");
var GridHeaderRow = /** @class */ (function (_super) {
    __extends(GridHeaderRow, _super);
    function GridHeaderRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridHeaderRow.prototype.render = function () {
        var _this = this;
        return React.createElement("tr", null, this.props.columns.map(function (column, index) {
            var key = "jt-header-th-" + index;
            return React.createElement(gridHeaderRowCell_1.GridHeaderRowCell, { settings: _this.props.settings, column: column, key: key, grouping: _this.props.grouping, groupCell: _this.props.groupCell, onClickHeader: _this.props.onClickHeader });
        }));
    };
    return GridHeaderRow;
}(React.Component));
exports.GridHeaderRow = GridHeaderRow;
//# sourceMappingURL=gridHeaderRow.js.map